import React from 'react';
import classNames from 'classnames';
import { Checkbox as AntCheckbox } from 'antd';
import { CheckboxProps as AntdCheckboxProps } from 'antd/lib/checkbox';
import cn from './styles.module.scss';

export type CheckboxProps = AntdCheckboxProps;

export function Checkbox({
  checked,
  indeterminate,
  onChange,
  disabled,
  className,
  children,
  ...props
}: CheckboxProps) {
  return (
    <AntCheckbox
      checked={checked}
      disabled={disabled}
      indeterminate={indeterminate}
      onChange={onChange}
      classNames={{
        label: cn.label,
      }}
      className={classNames(
        className,
        cn.checkbox,
      )}
      {...props}
    >
      {children}
    </AntCheckbox>
  );
}
